module.exports = __webpack_public_path__ + "img/84.e79d0507.jpg";